import React from 'react'
import ProjectTemplate from '../../Projects/ProjectTemplate/ProjectTemplate'
import CheetSheetTemplate from '../CheetSheet/CheetSheetTemplate'
import { softwareEngineering } from '../../../utils/constants';

export default function SoftwareEngineering(props) {
    return (
        <>
            <ProjectTemplate name='Software Engineering' mode={props.mode} isValue={props.isValue} >
                <div className="aboutMe blogDiv">
                    {

                        softwareEngineering.map((category,index) =>(
                            <CheetSheetTemplate
                                key={index}
                                imgClass={category.imgClass}
                                heading={category.heading}
                                headStyle={category.headStyle}
                                des={category.des}
                                url={category.url}
                                divStyle={category.divStyle}
                                img={category.img}
                                headerStyle={category.headerStyle}
                                class={category.class}
                            />
                        ))
                    }
                </div>
            </ProjectTemplate>
        </>
    )
}
